module.exports = __webpack_public_path__ + "static/bestwestern.13c6a4f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bestwestern.jpg
// module id = 487
// module chunks = 46232061722965